import { parseVer4DetailResponse } from '#/api/adapters/envelope';
import { keysToSnake } from '#/api/adapters/wireCase';
import request from '#/utils/request';

/**
 * 庫存標籤列印。
 * `invStockIds`（→ `inv_stock_ids`）決定項目與順序。
 * 有改選單位才帶 `unitSelections`（→ `unit_selections`：inv_stock_id、mtr_unit_id）。
 * **禁止**傳數量、倍率、單位名稱、printer_ip／port／profile。
 *
 * @param {{
 *   invStockIds: string[],
 *   unitSelections?: { invStockId: string, mtrUnitId: string }[],
 * }} params
 * @returns {Promise<{ message?: string, route?: string, data: object }>}
 *   `data` 含 `printedCount` 等（camelCase）
 */
export async function printLabel({ invStockIds, unitSelections } = {}) {
  const body = { invStockIds };
  if (Array.isArray(unitSelections) && unitSelections.length > 0) {
    body.unitSelections = unitSelections.map((selection) => ({
      invStockId: selection?.invStockId,
      mtrUnitId: selection?.mtrUnitId,
    }));
  }

  const { data: raw } = await request.post(
    '/inv/inventory-stock/label/print',
    keysToSnake(body),
  );
  return parseVer4DetailResponse(raw);
}
